import { from } from 'apollo-link';

import httpLink from './httpLink';
import onErrorLink from './onErrorLink';

const links = from([onErrorLink, httpLink]);

export default links;
